/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IEmailValidationApi {
    getValidationList(cancelToken?: CancelToken): AxiosPromise<EmailValidationModel[]>;
    getValidationListAsFile(cancelToken?: CancelToken): AxiosPromise<FileResponse>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_EmailValidationApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_EmailValidationApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class EmailValidationApi implements IEmailValidationApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_EmailValidationApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_EmailValidationApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getValidationList(cancelToken?: CancelToken): AxiosPromise<EmailValidationModel[]> {
        let url_ = "/marketing/api/brands/EmailValidation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<EmailValidationModel[]>(options_);
    }

    getValidationListAsFile(cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/marketing/api/brands/EmailValidation/download";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<FileResponse>(options_);
    }
}

export interface EmailValidationModel {
    email?: string | undefined;
    result: EmailValidationResult;
    dateAdded?: Date | undefined;
}

export enum EmailValidationResult {
    Undeliverable = 0,
    Typo = 1,
    Risky = 2,
    AcceptAll = 3,
    Unknown = 4,
    Disposable = 5,
    Role = 6,
    InvalidSyntax = 7,
    SmtpValid = 8,
    VerifiedValid = 9,
    Pending = -1,
}

export type FileResponse = Blob;
